const Blockquote = ({ children }) => {
  return (
    <div className="blockquote">
        {children}
    </div>
  )
}

export default Blockquote